var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pxToRem } from '../../utils';
var formFieldStyles = {
    root: function (_a) {
        var props = _a.props, variables = _a.variables;
        return ({});
    },
    label: function (_a) {
        var props = _a.props;
        var type = props.type, inline = props.inline, required = props.required;
        return __assign({}, ((!type || (type !== 'radio' && type !== 'checkbox')) && {
            display: 'block',
        }), (inline && { marginRight: pxToRem(10), display: 'inline' }), (required && {
            '::after': {
                content: '"*"',
            },
        }));
    },
    control: function (_a) {
        var props = _a.props;
        var type = props.type;
        return __assign({}, (type &&
            (type === 'radio' || type === 'checkbox') && {
            marginRight: pxToRem(10),
        }));
    },
    message: function () { return ({
        display: 'block',
    }); },
};
export default formFieldStyles;
